<template>
  <b-tab>
    <template v-slot:title>Expenses</template>
    <div>

      <!-- Major Permissions -->
      <h4 class="text-black">View Expenses</h4>
      <div class="mb-2 border-bottom row" v-for="(item, index) in permissions" :key="index">
        <div class="col-2">{{ item.rolename }}</div>
        <div class="col">
          <RockerSwitch v-if="item.view_expenses == 1" :value="true"
            @change="changePermission(role = item.role, permission = 'view_expenses')" />
          <RockerSwitch v-else :value="false"
            @change="changePermission(role = item.role, permission = 'view_expenses')" />
        </div>
      </div>

      <!-- Sub Tabs -->
      <div class="my-3 d-flex justify-content-evenly">
        <button @click.prevent="current_tab = 1" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 1 }">Expenses</button>
        <button @click.prevent="current_tab = 2" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 2 }">Categories</button>
        <button @click.prevent="current_tab = 3" class="btn btn-sm btn-primary"
          :class="{ 'btn-dark': current_tab == 3 }">Items</button>
      </div>
      <hr>

      <!-- Expenses -->
      <div v-show="current_tab == 1">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-3">Record New Expenses</div>
          <div class="col-3">View Expense Records</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- Record New Expenses -->
          <div class="col-3">
            <RockerSwitch v-if="item.record_expenses == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'record_expenses')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'record_expenses')" />
          </div>

          <!-- View Expense Records -->
          <div class="col-3">
            <RockerSwitch v-if="item.recorded_expenses == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'recorded_expenses')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'recorded_expenses')" />
          </div>
        </div>
      </div>

      <!-- Expense Categories -->
      <div v-show="current_tab == 2">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Categories</div>
          <div class="col-3">Add New Categories</div>
          <div class="col-2">Edit Categories</div>
          <div class="col-3">Delete Categories</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Categories -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_expense_categories == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_expense_categories')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_expense_categories')" />
          </div>

          <!-- New Categories -->
          <div class="col-3">
            <RockerSwitch v-if="item.new_expense_categories == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_expense_categories')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_expense_categories')" />
          </div>

          <!-- Edit Categories -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_expense_categories == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_expense_categories')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_expense_categories')" />
          </div>

          <!-- Delete Categories -->
          <div class="col-3">
            <RockerSwitch v-if="item.delete_expense_categories == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_expense_categories')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_expense_categories')" />
          </div>
        </div>
      </div>

      <!-- Expense Items -->
      <div v-show="current_tab == 3">
        <!-- Headings -->
        <div class="row fw-bold text-black mb-2">
          <div class="col-2">Role Name</div>
          <div class="col-2">View Expense Items</div>
          <div class="col-2">Add New Expense Items</div>
          <div class="col-2">Edit Expense Items</div>
          <div class="col-2">Delete Expense Items</div>
        </div>
        <!-- Data -->
        <div class="row mb-2 border-bottom" v-for="item in filteredPermissions" :key="item.id">
          <div class="col-2">{{ item.rolename }}</div>

          <!-- View Expense Items -->
          <div class="col-2">
            <RockerSwitch v-if="item.view_expense_items == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'view_expense_items')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'view_expense_items')" />
          </div>

          <!-- New Expense Items -->
          <div class="col-2">
            <RockerSwitch v-if="item.new_expense_items == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'new_expense_items')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'new_expense_items')" />
          </div>

          <!-- Edit Expense Items -->
          <div class="col-2">
            <RockerSwitch v-if="item.edit_expense_items == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'edit_expense_items')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'edit_expense_items')" />
          </div>

          <!-- Delete Expense Items -->
          <div class="col-2">
            <RockerSwitch v-if="item.delete_expense_items == 1" :value="true"
              @change="changePermission(role = item.role, permission = 'delete_expense_items')" />
            <RockerSwitch v-else :value="false"
              @change="changePermission(role = item.role, permission = 'delete_expense_items')" />
          </div>
        </div>
      </div>
    </div>
  </b-tab>
</template>

<script>
import axios from "axios";
import RockerSwitch from "vue-rocker-switch";
import "vue-rocker-switch/dist/vue-rocker-switch.css";
import appConfig from "@/app.config";
import { permissionMethods } from "@/state/helpers";

export default {
  name: "ExpensePermissions",
  page: {
    title: "System Permissions",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  props: {
    permissions: Array,
  },
  components: {
    RockerSwitch
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Permissions",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Permissions", active: true, },],
      isBusy: true,
      role: '',
      permission: '',
      current_tab: 1,
    };
  },
  computed: {
    filteredPermissions() {
      return this.permissions.filter((permission) => permission.view_expenses == 1);
    },
  },
  methods: {
    ...permissionMethods,
    async changePermission(role, permission) {
      this.role = role;
      this.permission = permission;
      let formData = new FormData();
      formData.append("role", this.role);
      formData.append("permission", this.permission);
      let url = "/updatepermission";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPermissions();
          this.role = "";
          this.permission = "";
        }
      });
    },
  },
};
</script>